/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const Nose4 = ({ className }) => {
  return (
    <svg
      className={`nose-4 ${className}`}
      fill="none"
      height="8"
      viewBox="0 0 15 8"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M4.36328 2.89355C4.36328 4.04546 5.76748 4.97927 7.49964 4.97927C9.23181 4.97927 10.636 4.04546 10.636 2.89355"
        fill="black"
        fillOpacity="0.16"
        fillRule="evenodd"
      />
    </svg>
  );
};
